import React from 'react';
import styled from 'styled-components';
import SuccessCheck from './SuccessCheck';
import { Body5, Container } from '@ui';

const CompleteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export default function Complete({ message }) {
  return (
    <CompleteWrapper>
      <SuccessCheck />
      <Container left={12}>
        <Body5>{message || 'Complete'}</Body5>
      </Container>
    </CompleteWrapper>
  );
}
